import React, { useState } from 'react';
import { ChromePicker } from 'react-color';
import styled from '@emotion/styled';
import Select from 'react-select';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import { newErrorNotificationAction } from '../../modules/notifications/Actions';
import { connect } from 'react-redux';
import getLangData from '../../utils/getLangData';

const ColorPicker = props => {
  const {
    name,
    label,
    setField,
    value,
    children,
    color,
    onDelete,
    setFieldValue,
    error
  } = props;
  const [colorCode, setColorCode] = useState('sss');
  const onChangeHandler = () => {
    {
      /* onChangeComplete={}}*/
    }
  };

  return (
    <div className='form-group '>
      <label className='col-lg-3 col-form-label' htmlFor={name}>
        {label} :
      </label>
      <div style={{ display: 'flex' }}>
        <Container className='col-lg-4'>
          <p>{getLangData().general_words.basic_color}</p>
          <div style={{ display: 'flex', marginBottom: '10px' }}>
            {[
              'white',
              'black',
              'red',
              'green',
              'blue',
              'yellow',
              'cyan',
              'magenta'
            ].map(color => (
              <div
                onClick={() =>
                  value.length < 5
                    ? setFieldValue(name, [...value, color])
                    : error('Too Many Colors! 5 Max')
                }
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '15px',
                  backgroundColor: color,
                  marginRight: '5px'
                }}
              ></div>
            ))}
          </div>
          <p>{getLangData().general_words.color_picker}</p>
          <ChromePicker
            onChangeComplete={color => setColorCode(color.hex)}
            // onChangeComplete={(e)=> setColorCode(e.target.value)}
            // color={value[value.length - 1]}
            color={colorCode}
            width='100%'
          />
          <Button
            color='primary'
            // className="ml-5"
            style={{ margin: '10px auto', width: '100%' }}
            width='100%'
            onClick={() =>
              value.length < 5
                ? setFieldValue(name, [...value, colorCode])
                : error('Too Many Colors! 5 Max')
            }
            // onClick={() =>error('Too Many Colors! 5 Max')}
          >
            {getLangData().general_words.add_color}
          </Button>
        </Container>
        <div className='col-lg-3 d-flex flex-column'>
          {Array.isArray(value) &&
            value.map((i, index) => (
              <Button
                className='mb-3'
                onClick={() => {
                  const mappedColors = value.filter(item => item != i);
                  setFieldValue(name, mappedColors);
                }}
                // style={{backgroundColor: i}}
                startIcon={<DeleteIcon style={{ color: i }} />}
                variant='outlined'
                key={index}
              >
                <span style={{ color: i }}>{i}</span>
              </Button>
            ))}
        </div>
      </div>
    </div>
  );
};

export default connect(null, { error: newErrorNotificationAction })(
  ColorPicker
);

const Container = styled.div`
  .react-datepicker {
    background-color: #1e1e2d;
  }
  .react-datepicker-wrapper {
    display: block;
  }
  .react-datepicker-popper {
    z-index: 9999999;
  }
  .react-datepicker__input-container input {
    display: block;

    width: 100%;

    height: calc(1.5em + 1.3rem + 2px);

    padding: 0.65rem 1rem;

    font-size: 1rem;

    font-weight: 400;

    line-height: 1.5;

    color: #495057;

    background-color: #fff;

    background-clip: padding-box;

    border: 1px solid #e2e5ec;

    border-radius: 4px;

    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .react-datepicker__header {
    background-color: #1a1a27;
    border-bottom: none;
  }
  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header,
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: #fff;
  }
  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover {
    background-color: #000;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range {
    background-color: #216ba5;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    margin-bottom: -7px;
  }
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle {
    margin-top: -7px;
  }

  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::before {
    border-bottom-color: #1e1e2d;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::before,
  .react-datepicker__year-read-view--down-arrow::before,
  .react-datepicker__month-read-view--down-arrow::before,
  .react-datepicker__month-year-read-view--down-arrow::before {
    border-top-color: #1e1e2d;
  }
`;
